/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED CONTROLS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	embedcontrols: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		marginBottom: pxToEm(15),
		'& .group': {
			display: 'flex',
			alignItems: 'center',
			'&:nth-child(1)': { },
			'&:nth-child(2)': { flex: '1', justifyContent: 'center', paddingLeft: pxToEm(10), paddingRight: pxToEm(10) },
			'&:nth-child(3)': { justifyContent: 'flex-end' }
		},
		'& .embedname': {
			marginBottom: '0'
		},
		'& .ctas': {
			display: 'inline-flex',
			'& .button': {
				height: pxToEm(48),
				width: pxToEm(156),
				'&:last-child': {
					// marginLeft: pxToEm(15)
				}
			}
		},
		'&.embedChangeDetected-true': {
			'& .group': {
				transition: 'all .2s linear 0s',
				'&:nth-child(1)': { extend: disable },
				'&:nth-child(2)': { extend: disable }
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: { 
		embedcontrols: {
			flexDirection: 'column',
			'& .group': {
				width: '100%',
				'&:nth-child(1)': { justifyContent: 'center', marginBottom: pxToEm(15) },
				'&:nth-child(3)': { flex: '0', justifyContent: 'center', marginTop: pxToEm(12) }
			}
		}
	}
});